export enum RigTypeList {
  none = 'none',
  semi = 'semi',
  jackup = 'jackup',
  platform = 'platform',
  landRig = 'landRig',
  drillship = 'drillship',
}
